// src/components/ProtectedRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import Unauthorized from './Unauthorized';

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole) {
    const roles = Array.isArray(requiredRole) ? requiredRole : [requiredRole];
    if (!roles.includes(user?.role)) {
      // Portal users who somehow hit an admin route — send them home
      if (user?.role === 'tenant') return <Navigate to="/portal/tenant/dashboard" replace />;
      if (user?.role === 'owner') return <Navigate to="/portal/owner/dashboard" replace />;
      if (user?.role === 'vendor') return <Navigate to="/portal/vendor/dashboard" replace />;

      // Staff user lacks the required role — show access denied screen
      return <Unauthorized />;
    }
  }

  return children;
};

export default ProtectedRoute;